/* eslint-disable @typescript-eslint/explicit-function-return-type */
const registrations = [
    {
        name: 'PartnersList',
        component: () => import(/* webpackChunkName: "partners" */ './partners/PartnersRoot'),
    },
    {
        name: 'PartnerProjectsList',
        component: () => import(
        /* webpackChunkName: "partner-projects-list" */ './partners/listing/PartnerProjectsListingRoot'),
    },
    {
        name: 'PartnerProjectsAllList',
        component: () => import(
        /* webpackChunkName: "partner-projects-all-list" */ './partners/listing/PartnerProjectsAllListingRoot'),
    },
    {
        name: 'PartnerShowcaseList',
        component: () => import(
        /* webpackChunkName: "partner-showcase-list" */ './partners/listing/PartnerShowcaseListingRoot'),
    },
    {
        name: 'PartnerCaseStudiesList',
        component: () => import(
        /* webpackChunkName: "partner-casestudies-list" */ './partners/listing/PartnerCaseStudiesListingRoot'),
    },
    {
        name: 'PartnerSuccessStoriesList',
        component: () => import(
        /* webpackChunkName: "partner-successstories-list" */ './partners/listing/PartnerSuccessStoriesListingRoot'),
    },
    {
        name: 'PartnerItemsListingFilter',
        component: () => import(
        /* webpackChunkName: "partner-items-listing-filter" */ './partners/listing/PartnerItemsListingFilterRoot'),
    },
    {
        name: 'PartnerProjectsAllListingTagsFilter',
        component: () => import(
        /* webpackChunkName: "partner-projects-all-listing-tags-filter" */ './partners/listing/PartnerProjectsAllListingTagsFilterRoot'),
    },
    {
        name: 'PartnerProjectsAllListingIndustriesFilter',
        component: () => import(
        /* webpackChunkName: "partner-projects-all-listing-industries-filter" */ './partners/listing/PartnerProjectsAllListingIndustriesFilterRoot'),
    },
    {
        name: 'DocumentList',
        component: () => import(/* webpackChunkName: "document-list" */ './listing/ListingRoot'),
    },
    {
        name: 'BlogRelatedList',
        component: () => import(
        /* webpackChunkName: "document-list-simple" */ './blog/listing/BlogRelatedListingRoot'),
    },
    {
        name: 'SlidesLivePresentationList',
        component: () => import(
        /* webpackChunkName: "slideslive-presentation-list" */ './listing/presentation/ListingRoot'),
    },
];
export default registrations;
